module.exports = __webpack_public_path__ + "static/media/checkmark.30c98631.gif";